import React from 'react';
import { colors, radii } from '../../theme';

const baseField = (error) => ({
  padding: '10px 13px',
  border: `1px solid ${error ? colors.danger : colors.borderStrong}`,
  borderRadius: radii.md,
  fontSize: 14,
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
  background: colors.surface,
  color: colors.text,
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
});

const labelStyle = { fontSize: 13, fontWeight: 600, color: colors.text };
const errStyle = { fontSize: 12, color: colors.danger };

export default function Input({ label, error, style, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      {label && <label style={labelStyle}>{label}</label>}
      <input style={{ ...baseField(error), ...style }} {...props} />
      {error && <span style={errStyle}>{error}</span>}
    </div>
  );
}

export function Select({ label, error, children, style, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      {label && <label style={labelStyle}>{label}</label>}
      <select style={{ ...baseField(error), cursor: 'pointer', ...style }} {...props}>
        {children}
      </select>
      {error && <span style={errStyle}>{error}</span>}
    </div>
  );
}

export function Textarea({ label, error, style, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      {label && <label style={labelStyle}>{label}</label>}
      <textarea style={{ ...baseField(error), minHeight: 80, resize: 'vertical', ...style }} {...props} />
      {error && <span style={errStyle}>{error}</span>}
    </div>
  );
}
